<template>
  <a-dialog v-model="show" scrollable persistent>
    <v-card>
      <v-banner color="primaryLight1" sticky single-line tile>
        <v-toolbar color="primaryLight1">
          <span>{{ $t("agenda.lblCheckStatus") }}</span>
          <v-spacer></v-spacer>
          <CloseIcon @click="show = false" />
        </v-toolbar>
      </v-banner>

      <v-card-text>
          <a-data-table
            :headers="headers"
            :items="items"
            dense
            :no-data-text="$t('noData')"
            :no-results-text="$t('emptySearchRecords')"
          >
            <template v-slot:item.status="{ item }">
              <v-chip small :color="getFilterStatusColor(item)" dark>
                {{ getFilterStatusLable(item.status) }}
              </v-chip>
            </template>
            <template v-slot:item.request_datetime="{ item }">
              {{ formatDate(new Date(item.request_datetime)) }}
            </template>
            <template v-slot:item.signing_datetime="{ item }">
              {{
                item.signing_datetime
                  ? formatDate(new Date(item.signing_datetime))
                  : ""
              }}
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                text
                color="primary"
                @click="resendSignature(item)"
                class="text-capitalize"
                v-if="item.status !== '99'"
              >
                {{ $t("agenda.lblResend") }}
              </v-btn>
              <span v-else >--</span>
            </template>
          </a-data-table>
      </v-card-text>
      <MessageSheet
      :showMessage="displayMessage"
      :message="message"
      :messageType="messageType"
      @close="displayMessage = false"
    ></MessageSheet>
    </v-card>
  </a-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { formatDate } from "@/utils/util";
import agendaService from "../../../api/agendaService";
import MessageSheet from "@/components/MessageSheet.vue";
export default {
  name: "CheckSignerStatus",
  components: {
    MessageSheet,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    meetingId: String,
    signingInfo: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      displayMessage: false,
      message: "",
      messageType: "",
    };
  },
  computed: {
    ...mapState({
      userList: (state) => state.people.userList,
      meetingObject: (state) => state.meeting.meetingDetails,
      getProvider: (state) => state.agenda.e_signature_provider,
    }),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    tenantName() {
      const users = this.$auth.user[process.env.VUE_APP_TENANT_KEY];
      const tenant = users.find((u) => u.id === this.selectedTenant);
      if (tenant) {
        return tenant.name;
      }
      return "";
    },
    headers() {
      let columns = [
        {
          text: this.$t("search.fileName"),
          align: "start",
          value: "document_name",
          class: "header header-text",
        },
        {
          text: this.$t("agenda.lblSignerName"),
          value: "signerName",
          align: "start",
          sortable: false,
          class: "header header-text",
        },
        {
          text: this.$t("agenda.lblEmailAddress"),
          value: "email",
          align: "start",
          class: "header header-text",
        },
        // {
        //   text: "Routing order",
        //   value: "routingOrder",
        //   class: "header header-text",
        // },
        {
          text: this.$t("activity.status"),
          value: "status",
          sortable: false,
          class: "header header-text",
        },
        {
          text: this.$t("agenda.lblDateSign"),
          value: "signing_datetime",
          sortable: false,
          class: "header header-text",
        },
        {
          text: this.$t("agenda.lblDateRequest"),
          value: "request_datetime",
          sortable: false,
          class: "header header-text",
        },
        {
          text: this.$t("admin.lblAction"),
          value: "action",
          sortable: false,
          class: "header header-text text-center",
        },
      ];
      if(this.getProvider && this.getProvider === "Cygnature"){
        columns = columns.filter(col => col.value !== 'action');
      }
      return columns;
    },
    items() {
      return this.signingInfo.map((signer) => {
        const user = this.userList.find(
          (user) =>
            String(user.registered_email).toLowerCase() ===
            String(signer.email).toLowerCase()
        );
        return {
          ...signer,
          signerName:
            user && user.firstName
              ? `${user.firstName} ${user.lastName}`
              : signer.email,
          id: user ? user.id : "",
          firstName: user ? user.firstName : "",
          lastName: user ? user.lastName : "",
          profilePhoto: user ? user.profilePhoto : "",
          title: user ? user.title : "",
        };
      });
    },
  },
  methods: {
    ...mapActions({
      momSignatureDocumentStatus: "agenda/momSignatureDocumentStatus",
      getObservers: "agenda/getObservers",
    }),
    getFilterStatusColor,
    getFilterStatusLable,
    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },
    formatDate,
    async resendSignature(item) {
      let toList = [
        [item.email, item.signerName]
      ];
      const email_ids = [item.email];
      let personalisedData = {
        [item.email]: {
          targetId: this.meetingId,
          emailDearRecipient: this.$t("email.emailDearRecipient", {
            username: item.signerName,
          }),
          username: item.signerName,
          tenantName: this.tenantName,
          template_id: process.env.VUE_APP_REMIND_VOTING_TEMPLATE_ID,
          subject: this.$t("email.signerSubject"),
          message: this.$t("email.signerMessage", {
            tenantName: this.tenantName,
            meetingName: this.meetingObject.meetingName,
            AccessCode: "{AccessCode}",
          }),
          emailPreHeader: this.$t("email.emailPreHeader"),
        },
      };
      
      const data = {
        meetingid: this.meetingId,
        sgTemplateId: process.env.VUE_APP_REMIND_VOTING_TEMPLATE_ID,
        document_info: {
            organize_nm: item.organize_nm,
            name_nm: item.name_nm,
            document_token: item.document_token
        },
        email_id: item.email,
        toList: toList,
        isPersonalised: true,
        personalisedData,
      };
      try {
        const result = await agendaService.resendSignature(data);
        if(result.status){
          this.showMessageSheet(
              this.$t("email.msgSignerSendEmailNotification"),
              "success"
            );
        } else {
            this.showMessageSheet(this.$t("agenda.msgEmailNotificationFaild"), "error");
          }
        return result;
      } catch (error) {
        console.error(error);
      }
      
    },
    
  },
};

function getFilterStatusLable(status) {
  //   1:Unopened
  // 2:Opened (not signed)
  // 3:Returned
  // 99:Signed
  if (status === "99") {
    return this.$t("agenda.lblSigned");
  }
  if (status === "2") {
    return this.$t("agenda.lblNotSigned");
  }
  if (status === "3") {
    return this.$t("agenda.lblReturned");
  }
  if (status === "1") {
    return this.$t("agenda.lblUnopened");
  }
  return this.$t("agenda.lblUnopened");
}

function getFilterStatusColor(item) {
  //   1:Unopened
  // 2:Opened (not signed)
  // 3:Returned
  // 99:Signed
  if (item.status === "99") {
    return "success";
  }
  if (item.status === "2") {
    return "error";
  }
  if (item.status === "3") {
    return "warning";
  }
  if (item.status === "1") {
    return "warining";
  }
  return "error";
}
</script>

<style  scoped>
::v-deep .v-banner__wrapper {
  padding: 0px !important;
}
</style>